import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { TileTypes } from 'generated/graphql-types';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-tile-type-icon',
    templateUrl: './tile-type-icon.component.html',
    styleUrls: ['./tile-type-icon.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TileTypeIconComponent {
   @Input() type: TileTypes;

   tileTypes = TileTypes;
}
